// The Whole Story – shared behaviour: scroll reveal + lazy background videos. Loaded deferred once.
// Sliders use Swiper – see assets/twst-swiper.js.
(() => {
  // Reveal elements marked with [data-twst-reveal] (also children get a stagger index)
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px' })
    : null;

  const scan = (root = document) => {
    root.querySelectorAll('[data-twst-reveal]:not(.is-in)').forEach((el) => {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  };
  // Muted background videos: load + play only while visible
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const vio = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach(({ target: v, isIntersecting }) => {
          if (isIntersecting && !reduced) {
            v.muted = true;
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  const scanVideos = (root = document) => {
    root.querySelectorAll('video[data-twst-autoplay]').forEach((v) => vio?.observe(v));
  };

  // Sound button ([data-twst-sound], placed next to its video): one video with sound at a time.
  // The icon follows the video's real state, also when the observer above mutes it again on scroll.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('[data-twst-sound]');
    const v = btn?.parentElement.querySelector('video');
    if (!v) return;
    e.preventDefault();
    e.stopPropagation();
    const unmute = v.muted;
    document.querySelectorAll('video').forEach((other) => {
      if (other !== v) other.muted = true;
    });
    v.muted = !unmute;
    if (unmute) v.play().catch(() => {});
  });
  document.addEventListener('volumechange', (e) => {
    const v = e.target;
    const btn = v instanceof HTMLVideoElement && v.parentElement?.querySelector('[data-twst-sound]');
    if (!btn) return;
    btn.classList.toggle('is-unmuted', !v.muted);
    btn.setAttribute('aria-pressed', String(!v.muted));
    btn.setAttribute('aria-label', v.muted ? btn.dataset.labelUnmute : btn.dataset.labelMute);
  }, true);

  scan();
  scanVideos();
  document.addEventListener('shopify:section:load', (e) => {
    scan(e.target);
    scanVideos(e.target);
  });
})();
